// AgeDistributionChart.tsx
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { formatNumber } from "../../../services/mixin";
import { Spin } from "antd";
import { formatPrice } from "../../../until";
import { useNavigate } from "react-router-dom";
import { IDataDefaulFilter } from "../ReportCustomer";

interface props {
    data: any[]
    showLoading: boolean
    dataFilter: IDataDefaulFilter

}


export const AgeDistributionChart: React.FC<props> = ({ data, showLoading, dataFilter }) => {
    const navigate = useNavigate()
    const convertAgeRangeToValue = (value?: string | null): number | undefined => {
        if (!value) return undefined;

        const normalized = value
            .trim()
            .replace(/\s+/g, "");

        const ageRangeMap: Record<string, number> = {
            "Khôngxácđịnh": 0,
            "0-18": 1,
            "18-25": 2,
            "26-35": 3,
            "36-45": 4,
            "46-55": 5,
            "56+": 6,
        };

        return ageRangeMap[normalized];
    };

    const convertNumberToLabelVehicle = (value?: number | null): string | undefined => {
        if (!value) return undefined;


        const ageRangeMap: Record<number, string> = {
            1: "Xe sở hữu",
            2: "Xe sử dụng",
            3: "Xe quan tâm",
        };

        return ageRangeMap[value];

    };



    const handleNavigate = (e: any, vehicleType: number) => {
        navigate(
            `/analysis-report/customers-card-list`,
            {
                state: {
                    firstPage: '/analysis-report/customers',
                    dataFilter,
                    ageVehicle: convertAgeRangeToValue(e.payload.age),
                    vehicleType: vehicleType,
                    title: `Danh sách xe ${convertNumberToLabelVehicle(vehicleType)} trong độ tuổi ${e.payload.age}`
                }
            }
        )
    }


    return (
        <div className="custom-pape-css w-full rounded-2 p-4 border"
            style={{ border: '1px solid #eaebec' }}
        >
            <h3 className="custom-page-css text-base text-344054 font-medium pb-4">
                Biểu đồ khách hàng sở hữu, sử dụng và quan tâm xe theo độ tuổi
            </h3>

            <div style={{ width: "100%", height: 360 }}>
                {
                    showLoading ?

                        <ResponsiveContainer>
                            <BarChart
                                data={data}
                                barGap={6}
                                barCategoryGap={20}
                                margin={{ left: 20 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="age" />
                                <YAxis tickFormatter={(value: number) => formatPrice(value)} />
                                <Tooltip
                                    labelFormatter={(label) => `${label}`}
                                    formatter={(value: number, name: string) => [
                                        formatNumber(value ?? 0),
                                        name
                                    ]}
                                />
                                <Legend />

                                <Bar
                                    dataKey="owned"
                                    name="Xe sở hữu"
                                    fill="#FF928A"
                                    radius={[4, 4, 0, 0]}
                                    cursor="pointer"
                                    // onClick={(entry) => console.log({
                                    //     ageVehicle: convertAgeRangeToValue(entry.payload.age),
                                    //     vehicleType: 1,
                                    //     value: entry.payload.owned,
                                    // })}
                                    onClick={(entry) => handleNavigate(entry, 1)}
                                />
                                <Bar
                                    dataKey="used"
                                    name="Xe sử dụng"
                                    fill="#8979FF"
                                    radius={[4, 4, 0, 0]}
                                    cursor="pointer"
                                    onClick={(entry) => handleNavigate(entry, 2)}
                                />
                                <Bar
                                    dataKey="interested"
                                    name="Xe quan tâm"
                                    fill="#2BB7DC"
                                    radius={[4, 4, 0, 0]}
                                    cursor="pointer"
                                    onClick={(entry) => handleNavigate(entry, 3)}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                        :
                        <div
                            className='custom-page-css flex flex-col gap-2 items-center justify-center'
                            style={{ width: '100%', height: '100%' }}
                        >
                            <Spin size="default" />
                            <span>Đang tải...</span>
                        </div>
                }
            </div>
        </div>
    );
};
